import React from "react";
import { Box, Typography } from "@mui/material";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";

const NoChatSelected = () => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100%"}
      bgcolor={"#f4f5f7"}
      flexDirection={"column"}
      textAlign={"center"}
      gap={1}
      px={3}
    >
      <ChatRoundedIcon sx={{ fontSize: 56, color: "#ffb877" }} />
      <Typography variant="h6" fontWeight={600}>
        Your messages
      </Typography>
      <Typography fontSize={14} color="text.secondary">
        Select a conversation to start chatting.
      </Typography>
    </Box>
  );
};

export default NoChatSelected;
